<script setup lang="ts">
import config from '@/common/config'
import { login } from '@/server/common/index'
import { useUserInfoStore } from '@/stores/useUserInfo'

const showLogin = defineModel('showLogin', { type: Boolean, default: false })

const mobile = ref('')
const smsCode = ref('')

const { city } = useCityInfoStore()

function setUserInfo() {
  /**
   * 校验mobile、smsCode
   * mobile正则校验
   */
  if (!mobile.value || !/^1[3-9]\d{9}$/.test(mobile.value)) {
    message.error('请输入正确的手机号')
    return
  }
  if (!smsCode.value) {
    message.error('请输入动态码')
    return
  }
  login({ mobile, smsCode, cityId: city }).then((res) => {
  })

  const store = useUserInfoStore()
  store.getUserInfo()
  const userInfo = store.userInfo

  // Cookie.set('userInfo', encodeURIComponent(JSON.stringify(userInfo)), config.COOKIEOPTIONS)
  // userInfo.muserId && Cookie.set('m-userid', userInfo.muserId, config.COOKIEOPTIONS)
  // userInfo.musername && Cookie.set('m-username', userInfo.musername, config.COOKIEOPTIONS)
  // userInfo.mheadImg && Cookie.set('m-headImg', userInfo.mheadImg, config.COOKIEOPTIONS)
  // userInfo.mmobile && Cookie.set('m-mobile', userInfo.mmobile, config.COOKIEOPTIONS)
  // userInfo.muserType && Cookie.set('m-userType', userInfo.muserType, config.COOKIEOPTIONS)

  useCookie('userInfo', { expires: config.COOKIEOPTIONS }).value = JSON.stringify(userInfo)
  userInfo.muserId && (useCookie('m-userid', { expires: config.COOKIEOPTIONS }).value = userInfo.muserId)
  userInfo.musername && (useCookie('m-username', { expires: config.COOKIEOPTIONS }).value = userInfo.musername)
  userInfo.mheadImg && (useCookie('m-headImg', { expires: config.COOKIEOPTIONS }).value = userInfo.mheadImg)
  userInfo.mmobile && (useCookie('m-mobile', { expires: config.COOKIEOPTIONS }).value = userInfo.mmobile)
  userInfo.muserType && (useCookie('m-userType', { expires: config.COOKIEOPTIONS }).value = userInfo.muserType)

  showLogin.value = false
  message.success('登录成功')
}

const countdown = ref<number>(0)

/**
 * 获取验证码
 */
function handleGetCode() {
  /**
   * TODO 对接获取验证码接口
   */
  /**
   * 倒计时效果
   */
  countdown.value = 60
  const timer = setInterval(() => {
    countdown.value -= 1
    if (countdown.value <= 0)
      clearInterval(timer)
  }, 1000)
}
</script>

<template>
  <a-modal v-model:open="showLogin" :footer="null" width="420px">
    <div class="login-box">
      <div class="tit">
        手机快捷登录
      </div>
      <div class="input">
        <div class="item">
          <input id="mobile" name="mobile" type="text" maxlength="11" placeholder="请输入手机号" style="width: 100%">
        </div>
        <div class="item">
          <input id="smsCode" name="smsCode" type="number" maxlength="6" placeholder="请输入动态码">
          <div class="yzm">
            <div class="bd" />
            <input v-if="countdown === 0" type="button" style="cursor: pointer" value="免费获取动态码" @click="handleGetCode();">
            <div v-else class="countdown">
              {{ countdown }}
            </div>
          </div>
        </div>
      </div>
      <div class="sub-btn">
        <input id="phone-login" type="button" value="登录" @click="setUserInfo()">
      </div>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
.login-box {
  padding: 20px 36px;

  .tit {
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    padding-bottom: 30px;
  }
  .input {
    .item {
      height: 50px;
      border: 1px solid #dcdcdc;
      margin-top: -2px;
      position: relative;
      background-color: #fff;
      overflow: hidden;

      input {
        height: 50px;
        line-height: 50px;
        border: none;
        width: 94%;
        padding: 0 3%;
        text-indent: 10px;
        background-color: transparent;
      }

      .yzm {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
        z-index: 2;
        background-color: #fff;

        .bd {
          position: absolute;
          height: 15px;
          width: 1px;
          overflow: hidden;
          left: 0;
          top: 17px;
          background-color: #dcdcdc;
        }

        .countdown {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
        }
      }
    }
  }
  .sub-btn {
    padding-top: 20px;
    input {
      margin-top: 25px;
      height: 50px;
      background-color: #1da838;
      cursor: pointer;
      border: none;
      color: #fff;
      font-size: 16px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      -ms-border-radius: 5px;
      -o-border-radius: 5px;
      border-radius: 5px;
      width: 100%;
    }
  }
}
</style>
